export default {
    'multiple-languages': {
        title: 'Versione 2.3: Keybreak parla sette lingue',
        excerpt: 'La versione 2.3 introduce il supporto per più lingue, l\'intera app e il sito web sono ora disponibili in sette lingue, e altre sono in arrivo.',
    },
    'micro-breaks': {
        title: 'Versione 2.2: micropause',
        excerpt: 'Dopo le richieste degli utenti, la versione 2.2 introduce le micropause: un piccolo messaggio nell\'angolo dello schermo ogni 10–15 minuti con una cosa da provare.',
    },
    'dynamic-hold-system': {
        title: 'Versione 2.1: tenute più intelligenti e feedback migliore',
        excerpt: 'La versione 2.1 aggiunge due cose: un modo per allungare al volo il tempo di tenuta e un nuovo sistema di animazioni che ti mostra esattamente a che punto sei di ogni tenuta.',
    },
    'science-of-sitting': {
        title: 'La scienza della sedentarietà: che cosa dice la ricerca sullo stare seduti tutto il giorno',
        excerpt: 'La sedentarietà è un fattore di rischio a sé, in gran parte indipendente dal fatto che tu faccia sport. Ecco che cosa mostra davvero la ricerca.',
    },
    'benefits-of-moving': {
        title: 'Perché muoversi di più durante la giornata di lavoro conta davvero',
        excerpt: 'Le pause regolari per muoversi non aiutano solo il corpo, ti rendono più lucido, meno stanco e più produttivo nell\'arco della giornata.',
    },
    'keybreak-launch': {
        title: 'Keybreak: il tuo compagno intelligente per le pause',
        excerpt: 'Dopo mesi di sviluppo, siamo felici di annunciare che Keybreak è ufficialmente disponibile, scaricabile gratis per Mac e Windows.',
    },
}
